module.exports = __webpack_public_path__ + "img/call.fb4d91af.png";